import { useEffect } from 'react';

import { useConsentStatus } from '@/ampli';
import { initGoogleAds } from '@/utils/google-ads';

/**
 * Initialises Google Ads once the user has accepted cookies. Consent status
 * reacts to both a returning consented visitor and a fresh "Accept" click.
 */
const GoogleAdsTag = () => {
  const isOptedIn = useConsentStatus() === 'optedIn';

  useEffect(() => {
    if (isOptedIn) {
      initGoogleAds();
    }
  }, [isOptedIn]);

  return null;
};

export default GoogleAdsTag;
